export enum AllowedAction {
  C = 'C',
  R = 'R',
  U = 'U',
  D = 'D',
}
